import React, { Component } from 'react'
import { Container, Row, Col } from 'react-grid-system'
import axios from 'axios'

// STYLES
import styled from 'styled-components'
import { Animated } from 'react-animated-css'

// HELPERS
import { Section } from '../../shared/helpers'

// COMPONENTS
import Title from '../../components/title/title.component'
import SubTitle from '../../components/subtitle/subtitle.component'
import ButtonSmall from '../../components/buttonsmall/buttonsmall.component'
import Checkbox from '../../components/checkbox/checkbox.component'

export default class More extends Component {
  constructor () {
    super()
    this.state = {
      name: '',
      email: '',
      phone: '',
      type: 'm',
      number: '',
      errorName: 0,
      errorEmail: 0,
      errorPhone: 0,
      errorNumber: 0,
      errorAssociateNumber: 0,
      isChecked: false,
      send: 0
    }
    this.setType = this.setType.bind(this)
    this.submitForm = this.submitForm.bind(this)
  }

  setType (type) {
    this.setState({ type: type })
  }

  submitForm () {
    const {
      name,
      email,
      phone,
      type,
      number,
      associateNumber,
      errorName,
      errorEmail,
      errorPhone,
      isChecked
    } = this.state
    let URL = process.env.REACT_APP_QUALITY_API + '/api/v1/qualification-request/'

    if (!this.validateForm(name, 0)) return
    if (!this.validateForm(email, 1)) return
    if (!this.validateForm(type, 2)) return
    if (!this.validateForm(number, 3)) return
    if (!this.validateForm(associateNumber, 4)) return

    if (errorName === 3 && errorEmail === 3 && errorPhone === 3 && isChecked) {
      axios.defaults.headers.common['AUTHORIZATION'] = 'TOKEN a3ccde025a96fa0bcc1b8818e51caf3dc2c33e12'
      axios.post(URL, {
        name: name,
        phone: phone,
        email: email,
        typology: type,
        rnal_id: number + '/AL',
        ahresp_associate_number: associateNumber
      })
        .then(res => {
          this.setState({ send: 1 })
          setTimeout(() => {
            this.setState({
              name: '',
              email: '',
              phone: '',
              type: 'm',
              number: '',
              associateNumber: '',
              errorName: 0,
              errorEmail: 0,
              errorPhone: 0,
              errorNumber: 0,
              errorAssociateNumber: 0,
              send: 0,
              isChecked: false
            })
          }, 10000)
        })
        .catch(res => {
          if (res.response.data) {
            if (res.response.data.email) {
              this.setState({
                send: 2
              })
            } else {
              this.setState({
                send: 3
              })
            }
          }
        })
    }
  }

	onChangeInput = (event, id) => {
	  let value = event.target.value
	  this.validateForm(value, id)
	}

	validateForm = (value, id) => {
	  if (id === 0) {
	    if (value.length < 3) {
	      this.setState({
	        name: value
	      })
	    } else {
	      let pattern = /^[a-z\u00C0-\u00FF.\s]+$/i
	      var isValid = pattern.test(value)
	      if (isValid) {
	        this.setState({
	          name: value,
	          errorName: 3
	        })

	        return true
	      } else {
	        this.setState({
	          name: value,
	          errorName: 2
	        })

	        return false
	      }
	    }
	  } else if (id === 1) {
	    let pattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
	    let isValid = pattern.test(value) && value.trim().length !== 0

	    if (isValid) {
	      this.setState({
	        email: value,
	        errorEmail: 3
	      })

	      return true
	    } else {
	      this.setState({
	        email: value,
	        errorEmail: 2
	      })

	      return false
	    }
	  } else if (id === 2) {
	    if (value.length < 9) {
	      this.setState({
	        phone: value
	      })

	      return true
	    } else {
	      let pattern = /^[0-9]+$/i
	      let isValid = pattern.test(value)
	      if (isValid) {
	        this.setState({
	          phone: value,
	          errorPhone: 3
	        })

	        return true
	      } else {
	        this.setState({
	          phone: value,
	          errorPhone: 2
	        })

	        return false
	      }
	    }
	  } else if (id === 3) {
	    this.setState({
	      number: value
	    })

	    return true
	  } else if (id === 4) {
	    this.setState({
	      associateNumber: value
	    })

	    return true
	  }
	}

	onChangeChecked = (value) => {
	  this.setState({
	    isChecked: !value
	  })
	}

	render () {
	  const {
	    email,
	    phone,
	    number,
	    associateNumber,
	    errorName,
	    errorEmail,
	    errorPhone,
	    errorNumber,
	    errorAssociateNumber,
	    send,
	    isChecked
	  } = this.state

	  const { t, id, i18n } = this.props

	  return (
  <Section id={id} className='backWhite'>
  <Container>
  <Title color={'#2E84C6'} text={t('Solicite o seu acesso à plataforma de certificação')} />
  <SubTitle color={'#5C5A5A'} text={t('Preencha o formulário abaixo e mantenha-se atualizado.')} />
	      </Container>

  <FormWrapper>
  {
	          send === 1 &&
						<Animated animationIn='fadeIn' animationOut='fadeOut' isVisible>
  <Send>
  <div>
  <p>{t('Obrigado pelo seu registo.')}</p>
  <p>{t('Daremos novidades brevemente!')}</p>
						    </div>
						  </Send>
						</Animated>
	        }
  {
	          send === 2 &&
						<Animated animationIn='fadeIn' animationOut='fadeOut' isVisible>
  <Error>
  <div>
  <p>{t('Este Email já esta a ser usado, por favor dirija-se a Área Reservada. Poderá recuperar a palavra-chave, ou contactar info@quality.ahresp.com')}</p>
						    </div>
						  </Error>
						</Animated>
	        }
  {
	          send === 3 &&
						<Animated animationIn='fadeIn' animationOut='fadeOut' isVisible>
  <Error>
  <div>
  <p>{t('Algo de errado se passou!')}</p>
  <p>{t('Por favor volte a tentar de novo, ou contactar info@quality.ahresp.com')}</p>
						    </div>
						  </Error>
						</Animated>
	        }
  <form>
  <FormContent>
  <Row>
  <Col md={12}>
  <FormTitle>
  {t('Dados Pessoais')}
	                </FormTitle>
	              </Col>
  <Col md={12}>
  <FormSection>
  <FormLabel>
  {t('Nome completo')} *
	                  </FormLabel>
  <FormInput
  type='text'
  value={this.state.name}
  onChange={(event, id) => this.onChangeInput(event, 0)}
	                  />
  {
	                    errorName === 1 &&
											<FormError>
  {t('Campo de preenchimento obrigatório')}
											</FormError>
	                  }
  {
	                    errorName === 2 &&
											<FormError>
  {t('Campo inválido')}
											</FormError>
	                  }
	                </FormSection>
	              </Col>
  <Col md={6}>
  <FormSection>
  <FormLabel>
  {t('Endereço de e-mail')}  *
	                  </FormLabel>
  <FormInput
  type='email'
  value={email}
  onChange={(event, id) => this.onChangeInput(event, 1)}
	                  />
  {
	                    errorEmail === 1 &&
											<FormError>
  {t('Campo de preenchimento obrigatório')}
											</FormError>
	                  }
  {
	                    errorEmail === 2 &&
											<FormError>
  {t('Campo inválido')}
											</FormError>
	                  }
	                </FormSection>
	              </Col>
  <Col md={6}>
  <FormSection>
  <FormLabel>
  {t('Telefone')} *
	                  </FormLabel>
  <FormInput
  type='number'
  value={phone}
  onChange={(event, id) => this.onChangeInput(event, 2)}
	                  />
  {
	                    errorPhone === 1 &&
											<FormError>
  {t('Campo de preenchimento obrigatório')}
											</FormError>
	                  }
  {
	                    errorPhone === 2 &&
											<FormError>
  {t('Campo inválido')}
											</FormError>
	                  }
	                </FormSection>
	              </Col>
  <Col md={12}>
  <FormTitle className='mt-4'>
  {t('Dados do Alojamento')}
	                </FormTitle>
	              </Col>
  <Col md={12}>
  <FormSection>
  <FormLabel>
  {t('Tipologia do alojamento')} *
	                  </FormLabel>
  <Tabs>
  <TabsItem onClick={() => this.setType('m')} className={this.state.type === 'm' ? 'activeTabMore' : ''}>
  <TabsText>
  {t('Moradia')}
	                      </TabsText>
	                    </TabsItem>
  <TabsItem onClick={() => this.setType('e')} className={this.state.type === 'e' ? 'activeTabMore' : ''}>
  <TabsText>
  {t('Estabelecimentos de Hospedagem')}
	                      </TabsText>
	                    </TabsItem>
  <TabsItem onClick={() => this.setType('h')} className={this.state.type === 'h' ? 'activeTabMore' : ''}>
  <TabsText>
  {t('Hostel')}
	                      </TabsText>
	                    </TabsItem>
  <TabsItem onClick={() => this.setType('a')} className={this.state.type === 'a' ? 'activeTabMore' : ''}>
  <TabsText>
  {t('Apartamento')}
	                      </TabsText>
	                    </TabsItem>
  <TabsItem onClick={() => this.setType('r')} className={this.state.type === 'r' ? 'activeTabMore' : ''}>
  <TabsText>
  {t('Quartos')}
	                      </TabsText>
	                    </TabsItem>
	                  </Tabs>
	                </FormSection>
	              </Col>
  <Col md={12}>
  <FormSection>
  <FormLabel>
  {t('Número de registo RNAL')}
	                  </FormLabel>
  <FormInputNumber
  type='number'
  value={number}
  onChange={(event, id) => this.onChangeInput(event, 3)}
	                  />
  <Al>
											/AL
	                  </Al>
  <FormLabelInfo>
  {t('Este campo deve conter apenas os números do seu registo,')} ex: 2345<span> /AL</span>
	                  </FormLabelInfo>
  {
	                    errorNumber === 1 &&
											<FormError>
  {t('Campo de preenchimento obrigatório')}
											</FormError>
	                  }
  {
	                    errorNumber === 2 &&
											<FormError>
  {t('Campo inválido')}
											</FormError>
	                  }
	                </FormSection>
	              </Col>

  <Col md={12}>
  <FormSection>
  <FormLabel>
  {t('Número de associado')}
	                  </FormLabel>
  <FormInputNumber
  type='number'
  step='0.01'
  noSpinner
  value={associateNumber}
  onChange={(event, id) => this.onChangeInput(event, 4)}
	                  />

  <FormLabelInfo>
  {t('Este campo deve conter apenas o seu número de associado')}
	                  </FormLabelInfo>
  {
	                    errorAssociateNumber === 2 &&
											<FormError>
  {t('Campo inválido')}
											</FormError>
	                  }
	                </FormSection>
	              </Col>

  <Col md={12}>
  {
	                  i18n.language === 'pt' &&
										<Links>
  <div>
  <a href='https://quality-ahresp.ubiwhere.com/filer/sharing/1526481164/24054/' target='_blank' rel='noopener noreferrer'>{t('Declaração de Consentimento')}</a>
										  </div>
  <div>
  <a href='https://quality-ahresp.ubiwhere.com/filer/sharing/1526481190/24057/' target='_blank' rel='noopener noreferrer'>{t('Regulamento do Programa')}</a>
										  </div>
										</Links>
	                }
  {
	                  i18n.language === 'en' &&
										<Links>
  <div>
  <a href='https://quality-ahresp.ubiwhere.com/filer/sharing/1526481174/24055/' target='_blank' rel='noopener noreferrer'>{t('Declaração de Consentimento')}</a>
										  </div>
  <div>
  <a href='https://quality-ahresp.ubiwhere.com/filer/sharing/1526481183/24056/' target='_blank' rel='noopener noreferrer'>{t('Regulamento do Programa')}</a>
										  </div>
										</Links>
	                }
  <CheckboxContent>
  <Checkbox onChange={this.onChangeChecked} value={isChecked} />
  <div>{t('Declaro que li e dou o meu consentimento.')}</div>
	                </CheckboxContent>
	              </Col>
	            </Row>
	          </FormContent>
  <FormFooter>
  <FormFooterLeft>
								* {t('dados de preenchimento obrigatório')}
	            </FormFooterLeft>
  <FormFooterRight>
  <ButtonSmall
  bgColor={
	                  errorName === 3 && errorEmail === 3 && errorPhone === 3 && isChecked ? '#2E84C6' : '#D5D5D5'
	                }
  color='#FFF'
  size='sm'
  text={t('Submeter')}
  clickAction={this.submitForm}
	              />
	            </FormFooterRight>
	          </FormFooter>
	        </form>
	      </FormWrapper>
	    </Section>
	  )
	}
}

const FormWrapper = styled.div`
    width: 652px;
    margin-right: auto;
    margin-left: auto;
    margin-top: 30px;

    @media screen and (max-width: 588px) {
        width: calc(100% - 30px);
        margin-right: 15px;
        margin-left: 15px;
    }
`
const FormContent = styled.div`
    width: calc(100% - 60px);
    padding: 30px;
    border: 1px solid rgba(110,110,110,0.1);
    border-radius: 4px;
    background-color: rgba(77,150,206,0.05);
    text-align: left;

    @media screen and (max-width: 588px) {
        width: calc(100% - 30px);
        padding: 15px;
    }
`
const FormTitle = styled.div`
    color: #4D96CE;
    font-family: "Source Sans Pro";
    font-size: 16px;
`
const FormSection = styled.div`
    width: 100%;
`
const FormLabel = styled.div`
    color: #5C5A5A;
    font-family: "Source Sans Pro";
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 5px;
    margin-top: 15px;
`
const FormInput = styled.input`
    width: calc(100% - 20px);
    padding: 10px;
    border-radius: 5px;
    border: 1px solid rgba(110,110,110,0.4);
    color: #041825;
    font-family: "Source Sans Pro";
    font-size: 16px;
    line-height: 20px;
    outline: none;

    &:focus{
        border-color: #2E84C6;
    }
`
const FormInputNumber = styled.input`
    width: calc(100% - 35px);
    padding-right: 25px;
    padding-top: 10px;
    padding-left: 10px;
    padding-bottom: 10px;
    border-radius: 5px;
    border: 1px solid rgba(110,110,110,0.4);
    color: #041825;
    font-family: "Source Sans Pro";
    font-size: 16px;
    line-height: 20px;
    outline: none;

    &:focus{
        border-color: #2E84C6;
    }

		${({ noSpinner }) => noSpinner &&
		`
		&::-webkit-inner-spin-button{
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			margin: 0; 
		}

		&::-webkit-outer-spin-button { 
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			margin: 0; 
	}
			`
}



`

const FormError = styled.div`
    color: #C63D2E;
    font-family: "Source Sans Pro";
    font-size: 12px;
    line-height: 15px;
    margin-top: 3px;
`
const FormLabelInfo = styled.div`
    color: #666;
    font-family: "Source Sans Pro";
    font-size: 12px;
    line-height: 15px;
    margin-top: 3px;

    span{
        color: red;
    }
`
const Tabs = styled.div`
    width: 100%;
    height: 40px;
    border-radius: 5px;
    border: 1px solid #2E84C6;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;

    @media screen and (max-width: 588px) {
        display: block;
        height: 203px;
    }
`
const TabsItem = styled.div`
    width: 25%;
    text-align: center;
    color: #2E84C6;
    font-family: Dosis;
    font-size: 13px;
    font-weight: bold;
    line-height: 16px;
    text-align: center;
    border-right: 1px solid #2E84C6;
    height: 40px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;

    &:last-child{
        border-right: 0px;
    }

    &:hover{
        background-color: #2E84C6;
        color: #FFF;

        &:nth-child(1){
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
        }
        &:nth-child(4){
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
        }
    }

    @media screen and (max-width: 588px) {
        width: 100%;
        border-right: 0px solid #2E84C6;
        border-top: 1px solid #2E84C6;

        &:nth-child(1){
            border-top: 0px solid #2E84C6;
        }

        &:hover{
            &:nth-child(1){
                border-bottom-left-radius: 0px;
                border-bottom-right-radius: 0px;
                border-top-right-radius: 3px;
            }

            &:nth-child(4){
                border-top-right-radius: 0px;
                border-bottom-right-radius: 3px;
                border-bottom-left-radius: 3px;
            }
        }
    }
`
const TabsText = styled.div`
    width: 100%;
    text-align: center;
`
const FormFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
`
const FormFooterLeft = styled.div`
    color: #5C5A5A;
    font-family: "Source Sans Pro";
    font-size: 14px;
    line-height: 18px;
`
const FormFooterRight = styled.div`
`
const Send = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #dff0d8;
    color: #3c763d;
    border-color: #d6e9c6;
    border-radius: 5px;
    height: 80px;
    margin-bottom: 15px;
    text-align: center;
    transition: all 0.2s ease;
    padding-left: 15px;
    padding-right: 15px;

    div {
        p{
            margin: 0;
            font-size: 14px;
        }

        p:first-child{
            margin-bottom: 5px;
        }
    }
`
const Error = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    border-radius: 5px;
    height: 80px;
    margin-bottom: 15px;
    text-align: center;
    padding-left: 15px;
    padding-right: 15px;

    div {
        p{
            margin: 0;
            font-size: 14px;
        }

        p:first-child{
            margin-bottom: 5px;
        }
    }
`
const Al = styled.span`
    position: absolute;
    top: 52px;
    right: 26px;
    color: red;
    background-color: white;
`
const CheckboxContent = styled.div`
    display: flex;
    align-items: center;
    margin-top: 30px;

    div {
      color: #5C5A5A;
      font-family: "Source Sans Pro";
      font-size: 14px;
      line-height: 18px;
      font-weight: 600;
    }
`
const Links = styled.div`
    margin-top: 20px;

    div {
      margin-top: 3px;
    }
    div a {
        font-family: "Source Sans Pro";
        color: #2E84C6;
        font-size: 12px;
        cursor: pointer;
        text-decoration: underline!important;
    }
`



// WEBPACK FOOTER //
// ./src/sections/more/more.component.js